
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter Relocation details:</p>
      </div>
    </div>
  </div>
  <form [formGroup]="deviceRelocationForm">
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="row">
          <div class="form-group col">
            <label class="required" for="deviceRelocationName">Name:</label>
            <input class="form-control" id="deviceRelocationName" formControlName="name" name="name" maxlength="75" required>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>